import useMount from '@src/utils/hooks/use-mount';
import { observable } from 'mobx';
import $$tracker from '@src/tracker';
import { aLink } from '@src/utils/common-util';

class AuditionStore {
  /**
   * 点击跳转
   */
  @observable redirect;
  onMeidaPageClick = (path, mediaType) => {
    $$tracker.clickStzxNav(mediaType);
    // this.redirect(path);
    aLink(window.location.origin + window.location.pathname + `#/${path}`);
  };
  constructor(options = {}) {
    Object.assign(this, options);
  }

  use() {
    useMount(async () => {
      console.log('componentDidMount');
    });
  }
}

export default AuditionStore;
